<mapfre-card [singleCard]="false" [additionalClasses]="'info-not-found'">
  <div class="policy-card">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon full-icon">
          <figure>
            <img src="./assets/img/images/expired.svg" alt="no match" />
          </figure>
        </div>
        <h1 class="info-title-add-policy">
          {{ "THE_INFORMATION_ENTERED_DOESNT_MATCH" | translate }}
        </h1>
      </div>
    </div>
    <div class="single-card-column policy-card">
      <div class="row margin-bottom mb24 mt-3">
        <div class="col">
          <div class="policy-info-content policy-account-flow">
            <ul class="txt-center">
              <li>
                {{ "POLICY" | translate }}:&nbsp;<strong>{{
                  policyNumber
                }}</strong>
              </li>
              <li>
                {{ "ZIP_CODE" | translate }}:&nbsp;<strong>{{
                  zipCode
                }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div class="text-center margin-vertical mv24">
          <mapfre-button
            additionalClasses="basic primary large-btn"
            (click)="goBack()"
          >
            {{ "REVIEW_DETAILS" | translate }}
          </mapfre-button>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          {{ "INFORMATION_IS_CORRECT" | translate }}
          <p>
            <a
              href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}"
              class="mapfre link red-link underline"
            >
              {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</mapfre-card>
